import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const pageInfoSelector = createSelector(selfSelector, (trackerStats) => trackerStats.pageInfo);

export default pageInfoSelector;
